import '../../../css/components/pages/logging-in-with-sso.css';
import { Loc } from 'main.core';
import { Ajax } from '../../api/ajax';
import { Analytics } from '../../api/analytics';
import { useLoggingInStore } from '../../pinia/store';
import { RoutePaths } from '../../routing/route-paths';
import { mapState, mapWritableState, mapActions } from 'ui.vue3.pinia';
import {
	SsoLoginForm,
} from 'b24network.vue.base-components';
import {
	UserRedirect,
	LoginValidator,
} from 'b24network.vue.cross-scenario-shared-js';

export const LoggingInWithSso = {
	name: 'LoggingInWithSso',

	components: {
		SsoLoginForm,
	},

	data(): Object
	{
		return {
			loginError: '',
			isNonSsoLoginForSsoPortal: false,
		};
	},

	computed: {
		...mapWritableState(useLoggingInStore, [
			'login',
			'navigationButtonType',
			'isNonSsoLoggingInForSsoPortal',
		]),

		...mapState(useLoggingInStore, [
			'enteredPortal',
			'forceSsoSignIn',
			'shouldShowCreateButtonOnAuthPage',
		]),

		headingText(): string
		{
			if (this.isNonSsoLoggingInForSsoPortal)
			{
				return Loc.getMessage('EXT_B24NET_LOGGING_IN_THIS_B24_HAS_SSO');
			}

			return Loc.getMessage('EXT_B24NET_LOGGING_IN_ENTER_WITH_SSO');
		},
	},

	watch: {
		login(newValue): void
		{
			this.loginError = '';
		},
	},

	mounted(): void
	{
		if (this.isNonSsoLoggingInForSsoPortal)
		{
			this.isNonSsoLoggingInForSsoPortal = false;
		}

		document.title = this.headingText;
		this.navigationButtonType = this.shouldShowCreateButtonOnAuthPage ? 'create-portal' : '';
	},

	methods: {
		...mapActions(useLoggingInStore, [
			'updateCurrentUserPortals',
		]),

		onSsoLoginChange(newLogin): void
		{
			this.login = newLogin;
		},

		async onSsoContinueClick(): void
		{
			this.loginError = LoginValidator.validateLogin(this.login, this.isPhoneEnabled);

			if (this.loginError.length > 0)
			{
				return;
			}

			Analytics.emitOnAuthorizationLoginEntered(this.login, true);

			try
			{
				const response = await Ajax.loadSsoPortals(this.login, this.enteredPortal);

				if (response.data?.portals?.length === 1)
				{
					this.redirectToPortalSso(response.data?.portals[0]);
				}
				else
				{
					this.updateCurrentUserPortals(response.data?.portals);
				}
			}
			catch (errorResponse)
			{
				this.updateLoginError(errorResponse);
			}
		},

		updateLoginError(errorResponse): void
		{
			if (errorResponse.errors?.length)
			{
				this.loginError = errorResponse.errors[0].message;
			}
			else
			{
				this.loginError = Loc.getMessage('EXT_B24NET_LOGGING_IN_UNKNOWN_ERROR_SIGN_IN');
			}
		},

		redirectToPortalSso(portal): void
		{
			if (portal.authUrl)
			{
				UserRedirect.redirectToUrl(portal.authUrl);
			}
			else
			{
				this.loginError = Loc.getMessage('EXT_B24NET_LOGGING_IN_UNKNOWN_ERROR_SIGN_IN');
			}
		},

		onEnterWithoutSsoClick(): void
		{
			this.login = '';
			this.$router.replace(RoutePaths.SIGN_IN);
		},
	},

	template: `
		<div class="b24net-logging-in-with-sso b24net-island">
			<h2 class="b24net-logging-in-with-sso__title" v-html="headingText"></h2>

			<SsoLoginForm
				:login-value="login"
				:login-error="loginError"
				@login-change="onSsoLoginChange"
				@continue-click="onSsoContinueClick"
				@enter-without-sso-click="onEnterWithoutSsoClick"
			/>
		</div>
	`,
};
